// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"NeedSupport_paragraph__cO9Kn","icon":"NeedSupport_icon__1MEUc","link":"NeedSupport_link__2_9oy","underline":"NeedSupport_underline__7ZJlj"};